import { motion } from 'framer-motion'
import SectionTitle from '../ui/SectionTitle'

const PROMISES = [
  {
    icon:  '✨',
    title: 'Stress-Free Planning',
    desc:  'We handle everything so you can relax and enjoy your child\'s special day.',
    color: '#FF6BB5',
  },
  {
    icon:  '🎯',
    title: 'Full Event Coordination',
    desc:  'From setup to cleanup, we\'ve got every detail covered — no surprises.',
    color: '#7C3AFF',
  },
  {
    icon:  '👨‍👩‍👧‍👦',
    title: 'Safe & Kid-Friendly Team',
    desc:  'Trained professionals who love working with children and know how to keep them safe.',
    color: '#FFC300',
  },
  {
    icon:  '🎨',
    title: 'Creative Themed Experiences',
    desc:  'Unique designs and magical touches tailored for every celebration and theme.',
    color: '#22C55E',
  },
]

const containerVariants = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.12 } },
}

const itemVariants = {
  hidden: { opacity: 0, y: 28 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
}

export default function WhyChooseUs() {
  return (
    <section className="section-padding bg-gradient-pink">
      <div className="container-custom">
        <SectionTitle
          eyebrow="Our Promise"
          title="Why Choose Farafeero?"
          subtitle="Happy birthday party"
        />

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-60px' }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {PROMISES.map(({ icon, title, desc, color }) => (
            <motion.div
              key={title}
              variants={itemVariants}
              whileHover={{ y: -6 }}
              className="bg-surface rounded-3xl p-7 shadow-card hover:shadow-glow-primary transition-all duration-300 text-center"
            >
              {/* Icon in colored circle */}
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center text-3xl mx-auto mb-5"
                style={{ backgroundColor: `${color}18`, border: `2px solid ${color}30` }}
              >
                {icon}
              </div>

              <h3 className="font-display text-ink text-lg mb-3">{title}</h3>
              <p className="font-body text-ink-muted text-sm leading-relaxed">{desc}</p>

              {/* Bottom accent */}
              <div
                className="mt-5 h-1 w-10 rounded-full mx-auto"
                style={{ background: color }}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
